import React, { useEffect, useState } from "react";
import ContentHeading from "../../../components/layout/content/ContentHeading";
import InputTextField from "../../../components/input/inputTextField";
import moment from "moment";
import TableCustom from "../../../components/table/tableCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { useTranslation } from "react-i18next";
import { RemoveRedEyeOutlined, SearchOutlined } from "@mui/icons-material";
import { dateToView, timeToView } from "../../../utils/date.utils";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import InputNewRangePicker from "../../../components/input/inputRankPicker";
import { debouncedApiCall } from "../../../utils/app.utils";
import { LogUserApi } from "../../../api/log-user/log-user.api";
import { facultyApi } from "../../../api/factulty/factulty.api";
import FilterSelect from "../../../components/select/filterSelect";
import { MenuItem } from "@mui/material";
import { ReportApi } from "../../../api/report/Report.api";
import { getFileExtension } from "../../../utils/fileTypeDownload";
import saveAs from "file-saver";
import { ButtonContained } from "../../../components/button/ButtonCustoms";
import StateComponents from "../../../components/state-component/StateComponents";

type Props = {};

const HistoryUsingClassShedule: React.FC<Props> = (props: Props) => {
  const navigate: NavigateFunction = useNavigate();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const [logHistory, setLogHistory] = useState([]);
  const [dataFaculty, setDataFaculty] = useState([]);

  const [search, setSearch] = useState<string>("");
  const [startDate, setStartDate] = useState<string>("");
  const [selectedFacultyId, setSelectedFacultyId] = useState<string>("");

  const [endDate, setEndDate] = useState<string>("");
  const [selectedDateRange, setSelectedDateRange] = useState<string[]>([]);
  const handleRangeDate = (value: any) => {
    setSelectedDateRange(value);
    setStartDate(moment(value[0]).format("YYYY-MM-DD"));
    setEndDate(moment(value[1]).format("YYYY-MM-DD"));
  };
  const handleClearRangeDate = () => {
    setSelectedDateRange([]);
    setStartDate("");
    setEndDate("");
  };

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(10);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const headCells = [
    {
      id: "#",
      width: 2,
      disablePadding: false,
      align: "center",
      label: "#",
    },
    {
      id: "fullname",
      width: 50,
      disablePadding: false,
      align: "start",
      label: t("ชื่อ-นามสกุล"),
    },
    {
      id: "nickname",
      disablePadding: false,
      width: 75,
      align: "center",
      label: t("ฉายา"),
    },
    {
      id: "type",
      disablePadding: false,
      align: "center",
      width: 75,
      label: t("รหัสประจำตัวนักศึกษา"),
    },
    {
      id: "date",
      disablePadding: false,
      align: "center",
      width: 75,
      label: t("หลักสูตร"),
    },
    {
      id: "time",
      disablePadding: false,
      align: "center",
      width: 75,
      label: t("การกระทำ"),
    },
    {
      id: "action",
      disablePadding: false,
      align: "center",
      width: 50,
      label: t("วันที่เข้าใช้งาน"),
    },
    {
      id: "action",
      disablePadding: false,
      align: "center",
      width: 50,
      label: t("เวลาที่เข้าใช้งาน"),
    },
  ];

  const renderData = (objData: any, index: any) => {
    index = page * pageLimit - pageLimit + index + 1;
    const {
      id_log_user,
      full_name,
      buddhist_name,
      id_faculty,
      faculty_name,
      list_api,
      log_event,
      no,
      log_date,
    } = objData;

    const objRenderData = {
      key: id_log_user,
      id: index,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "center",
          label: `${index}` || "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: `${full_name}` || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: buddhist_name || "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: no || "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: faculty_name || "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: log_event || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: dateToView(log_date) || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: timeToView(log_date) || "-",
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);

  const fetchGetLogHistory = async () => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
      start_date: startDate,
      end_date: endDate,
      id_faculty: selectedFacultyId,
      log_user_type: "STUDENT",
    };

    if (search) query = { ...query, keyword: search };

    const res = await LogUserApi.getHistoryList(query);
    const data = res.data;
    if (data.status < 300 && data.data && data.data.items.length > 0) {
      setTotalItems(res.data?.data?.meta?.totalItems || 0);
      setLogHistory(data.data.items);
    } else {
      setLogHistory([]);
    }
  };

  useEffect(() => {
    fetchGetLogHistory();
  }, [
    page,
    pageLimit,
    sortBy,
    sortType,
    startDate,
    endDate,
    search,
    selectedFacultyId,
  ]);
  const handleDownloadFile = async () => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
      start_date: startDate,
      end_date: endDate,
      id_faculty: selectedFacultyId,
      log_user_type: "STUDENT",
    };

    if (search) query = { ...query, keyword: search };
    dispatch(setLoading());
    await ReportApi.reportLogThesis(query)
      .then((res) => {
        if (res.status < 300) {
          const response = res.data;

          const contentType = res.headers["content-type"];

          const blob = new Blob([response], { type: contentType });

          const fileExtension = getFileExtension(contentType || "");

          const fileName = `${new Date().getTime()}.${fileExtension}`;

          saveAs(blob, fileName);
        }
      })
      .catch((error) => console.log(error))
      .finally(() => dispatch(unsetLoading()));
  };
  const fetchGetFaculty = async () => {
    let query: any = {
      page: 1,
      limit: 1000,
    };

    const res = await facultyApi.getFaculty();
    const data = res.data;
    if (data.status < 300 && data.data && data.data.length > 0) {
      setDataFaculty(data.data);
    } else {
      setDataFaculty([]);
    }
  };

  useEffect(() => {
    fetchGetFaculty();
  }, []);

  return (
    <div>
      <ContentHeading
        title={t("ประวัติการใช้งานเมนูตารางเรียน")}
        detail={t("กรุณาเลือกรายการที่ท่านต้องการ")}
      />

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-3  md:col-span-3  sm:col-span-3">
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder={t("ค้นหาชื่อ - นามสกุล/ชื่อฉายา")}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              debouncedApiCall({
                searchItem: e.target.value,
                setItem: setSearch,
              })
            }
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-3  md:col-span-3  sm:col-span-3">
          <InputNewRangePicker
            value={selectedDateRange}
            onchange={handleRangeDate}
            onClear={handleClearRangeDate}
            allowClear
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-3  md:col-span-3  sm:col-span-3">
          <FilterSelect
            value={selectedFacultyId ?? ""}
            labelId="academic_year-id"
            selectId="academic_year-select-id"
            options={[
              {
                id_faculty: "",
                faculty_name: t("ทุกหลักสูตร"),
              },
              ...dataFaculty.map((item: any, index) => ({
                id_faculty: item.id_faculty,
                faculty_name: i18n.language === "en" ? (item.faculty_name_eng || item.faculty_name) : item.faculty_name,
              })),
            ].map((year, index) => (
              <MenuItem value={year.id_faculty} key={index}>
                {year.faculty_name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setSelectedFacultyId(e.target.value)
            }
          />
        </article>
        <article className="w-full col-span-12 lg:col-span-3  md:col-span-3  sm:col-span-3">
          {/* <ButtonContained buttonName='LIST_APPLICANTS_DOWNLOAD_EXCEL' onClick={() => handleDownloadFile()} /> */}
          <StateComponents
            otherProps={{ spacing: 2 }}
            typeProps={[

              {
                seq: 6,
                type: "BUTTON",
                gridProps: {
                  xs: 12,
                },
                fieldProps: {
                  justifyContent: "flex-end",
                  buttonData: [
                    {
                      seq: 1,
                      key: "ADD2",
                      label: t("LIST_APPLICANTS_DOWNLOAD_EXCEL"),
                      buttonProps: {
                        onClick: () => {
                          handleDownloadFile()
                          // setShowModal("ADD")
                        },
                      },
                      type: "DOWNLOAD_CSV"
                    }
                  ]
                }
              }
            ]}
          />
        </article>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1640}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            logHistory &&
            logHistory.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </div>
  );
};

export default HistoryUsingClassShedule;
